import * as QueryString from 'query-string';
import React, { FC, useContext } from 'react';
import { RouteComponentProps } from 'react-router';
import { ConsumerSchedulingContext } from '../contexts/ConsumerSchedulingContext';
import { LandingStep } from '../components/LandingStep';

export const ConsumerSchedulingLandingPage: FC<RouteComponentProps> = ({ location }): JSX.Element => {
  const { organization } = useContext(ConsumerSchedulingContext);
  const params = QueryString.parse(location.search);

  return <LandingStep organization={organization} params={params} />;
};
